import { render, staticRenderFns } from "./ItsOrderLogisticCar.vue?vue&type=template&id=09baa62b&scoped=true&"
import script from "./ItsOrderLogisticCar.vue?vue&type=script&lang=js&"
export * from "./ItsOrderLogisticCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09baa62b",
  null
  
)

export default component.exports